import * as tslib_1 from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from "dayjs";
import * as echarts from "echarts/core";
// 引入柱状图图表，图表后缀都为 Chart
import { LineChart } from "echarts/charts";
import { TooltipComponent, LegendComponent, GridComponent, DatasetComponent, TransformComponent, } from "echarts/components";
import { LabelLayout, UniversalTransition } from "echarts/features";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";
import { getColumnStudayData, getColumnStudayList, getColumnStudayCount, getColumnTaskList } from '@/api/statistics';
import { getEnabledCampList, getEnabledTermList } from '@/api/student';
import { mixin_export } from '@/utils/exportFile';
// 注册必须的组件
echarts.use([
    TooltipComponent,
    LegendComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    LineChart,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer,
]);
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.instance = null;
        this.chartType = "last30";
        this.searchColumnId = '';
        this.props = {
            lazy: true,
            lazyLoad: async (node, resolve) => {
                const { level } = node;
                if (level <= 1) {
                    let nodes = level == 0 ? await this.getCampList() : await this.getTermList(node.value);
                    resolve(nodes);
                }
                else {
                    resolve([]);
                }
            }
        };
        this.columnList = [];
        this.chartTime = [
            dayjs()
                .subtract(29, "day")
                .format("YYYY-MM-DD"),
            dayjs().format("YYYY-MM-DD"),
        ];
        this.search = {
            keywordType: '1',
            keyword: ''
        };
        this.allStudyUsers = '0';
        this.tableData = [];
        this.total = 0;
        this.pageNo = 1;
        this.pageSize = 15;
        this.taskTitle = '';
        this.taskList = [];
        this.taskPageNo = 1;
        this.taskPageSize = 15;
        this.taskTotal = 0;
    }
    changeChart() {
        this.getData();
    }
    created() {
    }
    mounted() {
        this.initChart();
    }
    onSearch() {
        this.taskPageNo = 1;
        this.pageNo = 1;
        this.search.keyword = '';
        this.taskTitle = '';
        this.getStudyCount();
        this.getData();
        this.getTaskList();
        this.getList();
    }
    async getStudyCount() {
        if (!this.searchColumnId || this.searchColumnId.length == 0) {
            return;
        }
        let res = await getColumnStudayCount(this.searchColumnId[1]);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.allStudyUsers = res.data.data.allStudyUsers || 0;
    }
    async getCampList() {
        let res = await getEnabledCampList();
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        let list = [];
        res.data.data.map((item) => {
            list.push({
                label: item.title,
                value: item.id,
                leaf: false,
            });
        });
        return list;
    }
    async getTermList(id) {
        let res = await getEnabledTermList(id);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        let list = [];
        res.data.data.map((item) => {
            list.push({
                label: item.name,
                value: item.id,
                leaf: true,
            });
        });
        return list;
    }
    async getData() {
        if (!this.searchColumnId || this.searchColumnId.length == 0) {
            return this.$message.error('请选择训练营');
        }
        let data = {
            courseId: this.searchColumnId[1],
            startTime: this.chartTime[0],
            endTime: this.chartTime[1]
        };
        const res = await getColumnStudayData(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.renderChart(res.data.data || []);
    }
    onChangeTime(value) {
        this.chartTime = value;
    }
    onChangeType(value) {
        switch (value) {
            case "yesterday":
                this.chartTime = [
                    dayjs()
                        .subtract(1, "day")
                        .format("YYYY-MM-DD"),
                    dayjs()
                        .subtract(1, "day")
                        .format("YYYY-MM-DD"),
                ];
                break;
            case "today":
                this.chartTime = [
                    dayjs().format("YYYY-MM-DD"),
                    dayjs().format("YYYY-MM-DD"),
                ];
                break;
            case "last7":
                this.chartTime = [
                    dayjs()
                        .subtract(6, "day")
                        .format("YYYY-MM-DD"),
                    dayjs().format("YYYY-MM-DD"),
                ];
                break;
            case "last30":
                this.chartTime = [
                    dayjs()
                        .subtract(29, "day")
                        .format("YYYY-MM-DD"),
                    dayjs().format("YYYY-MM-DD"),
                ];
                break;
            case "custom":
                this.$refs.chartPicker.focus();
                break;
            default:
                break;
        }
    }
    initChart() {
        var chartDom = document.getElementById("main");
        this.instance = echarts.init(chartDom);
        const option = {
            tooltip: {
                trigger: "axis",
            },
            legend: {
                data: ["学习人次", "平均学习时长（分钟）"],
            },
            grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
            },
            xAxis: {
                type: "category",
                boundaryGap: false,
                data: [],
            },
            yAxis: {
                type: "value",
            },
            series: [
                {
                    name: "学习人次",
                    type: "line",
                    data: [],
                    smooth: true,
                },
                {
                    name: "平均学习时长（分钟）",
                    type: "line",
                    data: [],
                    smooth: true,
                }
            ],
        };
        this.instance.setOption(option);
    }
    renderChart(data) {
        if (this.instance) {
            const date = data.map((item) => {
                const month = item.day.split("-")[1];
                const day = item.day.split("-")[2];
                return `${month}-${day}`;
            });
            const studyUserCount = data.map((item) => item.studyUserCount);
            const studyTimeAvgMin = data.map((item) => item.studyTimeAvgMin);
            this.instance.setOption({
                xAxis: {
                    data: date,
                },
                series: [
                    {
                        data: studyUserCount,
                    },
                    {
                        data: studyTimeAvgMin,
                    }
                ],
            });
        }
    }
    onSearchTask() {
        this.taskPageNo = 1;
        this.getTaskList();
    }
    async getTaskList() {
        if (!this.searchColumnId || this.searchColumnId.length == 0) {
            return;
        }
        let data = {
            courseId: this.searchColumnId[1],
            pageNo: this.taskPageNo,
            pageSize: this.taskPageSize,
            title: encodeURIComponent(this.taskTitle)
        };
        const res = await getColumnTaskList(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.taskList = res.data.data.list || [];
        this.taskTotal = Number(res.data.data.total);
        this.taskPageNo = Number(res.data.data.pageNum);
    }
    changeTaskPage(pageNo) {
        this.taskPageNo = pageNo;
        this.getTaskList();
    }
    changeTaskPageSize(pageSize) {
        this.taskPageSize = pageSize;
        this.getTaskList();
    }
    onExportTask() {
        if (!this.searchColumnId || this.searchColumnId.length == 0)
            return this.$message.error('请选择训练营');
        this.$confirm('是否确认导出任务进度？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let data = {
                courseId: this.searchColumnId[1],
                title: encodeURIComponent(this.taskTitle)
            };
            mixin_export('/courseAdmin/userProgress/exportCourseTaskProgressStatistics', 'get', data);
        });
    }
    onSearchList() {
        this.pageNo = 1;
        this.getList();
    }
    async getList() {
        if (!this.searchColumnId || this.searchColumnId.length == 0) {
            return this.$message.error('请选择训练营');
        }
        let data = {
            courseId: this.searchColumnId[1],
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            keywordType: this.search.keywordType,
            keyword: this.search.keyword,
        };
        const res = await getColumnStudayList(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.tableData = res.data.data.list;
        this.total = Number(res.data.data.total);
        this.pageNo = Number(res.data.data.pageNum);
    }
    changePage(pageNo) {
        this.pageNo = pageNo;
        this.getList();
    }
    changePageSize(pageSize) {
        this.pageSize = pageSize;
        this.getList();
    }
    onExportStudyDetails() {
        if (!this.searchColumnId || this.searchColumnId.length == 0)
            return this.$message.error('请选择训练营');
        this.$confirm('是否确认导出学习详情？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let data = {
                courseId: this.searchColumnId[1],
                courseType: 2,
                keyword: this.search.keyword,
                keywordType: this.search.keywordType,
            };
            mixin_export('/courseAdmin/userProgress/exportCourseUserProgressStatistic', 'get', data);
        });
    }
    onJumpPro(userId) {
        this.$router.push({
            path: '/course-manager/progressList',
            query: {
                userId: userId,
                courseId: this.searchColumnId[1],
                courseType: '2'
            }
        });
    }
};
tslib_1.__decorate([
    Watch("chartTime")
], Login.prototype, "changeChart", null);
Login = tslib_1.__decorate([
    Component({
        filters: {
            formatType(type) {
                if (type === 1)
                    return '音频';
                if (type === 2)
                    return '视频';
                if (type === 3)
                    return '图文';
                if (type === 4)
                    return '考试';
                return '';
            }
        }
    })
], Login);
export default Login;
